import React, { useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import ListUnenrolledStudents from '../../../components/ListUnenrolledStudents'
import { Container, Row, Col } from 'react-bootstrap'
import ExportDocumentForm from '../../../components/ExportDocumentForm'
import Pagination from '../../../components/Pagination'
import SizePerPage from '../../../components/SizePerPage'
import { USE_API_NULL_VALUE } from '../../../constants/APIFields'
import { setPage, setSizePerPage, requestUpdateCandidateList, setFilters, setListDeleted } from '../../../redux/actions/candidatesListActions'
import { setExportDocumentParam } from '../../../redux/actions/exportDocumentActions'
import { getAllMajors } from '../../../redux/actions/majorActions'
import { getAllPeriods } from '../../../redux/actions/periodActions'
import SelectField from '../../../components/SelectField'
import TextField from '../../../components/TextField'

const ChiefCareer = ({ 
  candidatesList,
  majors,
  periods,
  setPage,
  setSizePerPage,
  requestUpdateCandidateList,
  getAllMajors,
  getAllPeriods,
  setListDeleted,
  setFilters,
  setExportDocumentParam
}) => {

  const { 
    page,
    sizePerPage,
    totalRecords, 
    records, 
    deleted,
    filters: { period, documentation, major, belate, enroll, shifting, name, control, documentPending } 
  } = candidatesList

  useEffect(() => {
    getAllMajors()
    getAllPeriods()
  }, [])

  const isSelectedPeriodActive = useCallback(() => period === '', [period])

  useEffect( () => {
    requestUpdateCandidateList(deleted, { page, sizePerPage, period, documentation, major, belate, enroll, shifting, name, control, documentPending })
  }, [page, sizePerPage, documentation, period, major, belate, enroll, shifting, name, control, documentPending, deleted])

  return (
    <Container fluid>
        <Row style={{top: '67px', zIndex: 2}}>
          <Col className='d-flex justify-content-between align-items-center bg-white'>
            <h1 className='mt-5 mb-4'>Aspirantes seleccionados</h1>
          </Col>
          <Col className="col-xl-4 col-lg-5 col-md-7 col-sm-12 col-12 justify-content-between my-auto bg-white">
            <Row>
              <Col className="bg-white">
                <div className="form-group">
                <SelectField
                  label='Periodo'
                  value={period}
                  options={periods}
                  onChange={(period) => {
                    setFilters({period})
                    setExportDocumentParam({period})
                  }}
                  className=""
                />
                </div>
              </Col>
              <Col className="bg-white">
                <div className="form-group">
                <SelectField
                  label='Lista de alumnos'
                  value={deleted}
                  placheholder='Seleccionar'
                  options={[
                    {value: 'false', label: 'Aceptados'},
                    {value: 'true', label: 'Inhabilitados'}
                  ]}
                  onChange={(value) => {
                    setListDeleted(value)
                  }}
                  className=""
                />
                </div>
              </Col>
              <Col className="col-12 col-sm-auto mt-auto bg-white">
                <div className="form-group text-right">
                  <ExportDocumentForm/>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <hr/>
        <h4>Filtrar Por</h4>
        <Row>
        <Col className="bg-white">
            <TextField
              label='Número de control'
              value={control}
              placheholder='Numero de control'
              onChange={(control) => {
                setFilters({control})
              }}
            />
          </Col>
          <Col className="bg-white">
            <TextField
              label='Nombre'
              value={name}
              placheholder='Nombre del Alumno'
              onChange={(name) => {
                setFilters({name})
              }}
            />
          </Col>
          <Col className="bg-white">
            <SelectField
              label='Carrera'
              value={major}
              options={majors}
              placeholder="Todos"
              onChange={(major) => {
                setFilters({major})
                setExportDocumentParam({major})
              }}
            />
          </Col>
          <Col className="bg-white">
            <SelectField
              label='Documentación'
              value={documentation}
              placeholder="Todos"
              options={[
                {value: 0, label: 'Listos para revisar'},
                {value: 1, label: 'Aprobado y Validado'},
                {value: USE_API_NULL_VALUE, label:'Faltan documentos'}
              ]}
              onChange={(documentation) => {
                setFilters({documentation})
                setExportDocumentParam({documentation})
              }}
            />
          </Col>
          <Col className="bg-white">
            <SelectField
              label='Estatus'
              value={enroll}
              placeholder="Todos"
              options={[
                {value: 0, label: 'No inscrito'},
                {value: 1, label: 'Inscrito'}
              ]}
              onChange={(enroll) => {
                setFilters({enroll})
                setExportDocumentParam({enroll})
              }}
            />
          </Col>
          <Col className="bg-white">
            <SelectField
              label='Pendiente'
              value={documentPending}
              placeholder="Todos"
              options={[
                {value: 0, label: 'No'},
                {value: 1, label: 'Si'}
              ]}
              onChange={(documentPending) => {
                setFilters({documentPending})
                setExportDocumentParam({documentPending})
              }}
            />
          </Col>
          {/* <Col className="bg-white">
            <SelectField
              label='Corrimiento'
              value={shifting}
              placeholder="Todos"
              options={[
                {value: 0, label: 'No'},
                {value: 1, label: 'Si'}
              ]}
              onChange={(shifting) => {
                setFilters({shifting})
              }}
            />
          </Col>
          <Col className="bg-white">
            <SelectField
              label='Tardias'
              value={belate}
              placeholder="Todos"
              options={[
                {value: 0, label: 'No'},
                {value: 1, label: 'Si'}
              ]}
              onChange={(belate) => {
                setFilters({belate})
                setExportDocumentParam({belate})
              }}
            />
          </Col> */}
        </Row>
        <hr/>
        <Row>
          <Col className='bg-white d-flex justify-content-between'>
              <SizePerPage
                currentSize={ sizePerPage }
                handleChange={ (size) => setSizePerPage(size) }
              />
              <Pagination
                currentPage={ page }
                currentSize= { sizePerPage }
                totalRecords={ totalRecords }
                handleChange={ (page) => setPage(page) }
              />
          </Col>
        </Row>
        <Row>
          <Col className='bg-white'>
              <ListUnenrolledStudents
                records= { records }
                majors={majors}
                allowEnrollmentStateToggle={isSelectedPeriodActive()}
              />
          </Col>
        </Row> 
        <Row>
          <Col className='bg-white d-flex justify-content-between'>
              <SizePerPage
                currentSize={ sizePerPage }
                handleChange={ (size) => setSizePerPage(size) }
              />
              <Pagination
                currentPage={ page }
                currentSize= { sizePerPage }
                totalRecords={ totalRecords }
                handleChange={ (page) => setPage(page) }
              />
          </Col>
        </Row>
    </Container>
  )
}

const mapStateToProps = ({ candidatesListReducer, majorsReducer, periodsReducer }) => {
  return { 
    candidatesList: candidatesListReducer,
    majors: majorsReducer,
    periods: periodsReducer
  }
}

const mapDispatchToProps = {
  getAllMajors,
  getAllPeriods,
  setPage,
  setSizePerPage,
  requestUpdateCandidateList,
  setFilters,
  setListDeleted,
  setExportDocumentParam
}

export default connect(mapStateToProps, mapDispatchToProps)(ChiefCareer)